import { useEffect, useState } from "react";
import {
  getAllRoles,
  getUserRoles,
  assignRole
} from "../api/adminApi";

const AssignRoleDrawer = ({ user, onClose }) => {

  const [roles, setRoles] = useState([]);
  const [selectedRole, setSelectedRole] = useState("");

  useEffect(() => {
    getAllRoles().then(r => setRoles(r.data));
  }, []);

  const handleAssign = async () => {

    await assignRole({
      userID: user.UserID,
      roleID: selectedRole
    });

    onClose();
  };

  if (!user) return null;

  return (
    <div className="fixed right-0 top-0 h-full w-[420px] bg-white shadow-2xl p-6 z-50">

      <h2 className="text-xl font-black mb-6">
        Assign Role — {user.Name}
      </h2>

      <select
        className="w-full border rounded-lg p-3"
        onChange={(e)=>setSelectedRole(e.target.value)}
      >
        <option>Select Role</option>
        {roles.map(r => (
          <option key={r.RoleID} value={r.RoleID}>
            {r.RoleName}
          </option>
        ))}
      </select>

      <button
        onClick={handleAssign}
        className="mt-6 w-full bg-blue-950 text-white py-3 rounded-lg font-bold"
      >
        Assign Role
      </button>

      <button
        onClick={onClose}
        className="mt-3 w-full border py-3 rounded-lg"
      >
        Close
      </button>

    </div>
  );
};

export default AssignRoleDrawer;